module.exports = __webpack_public_path__ + "img/george-politis.8ced775d.jpg";